<template>
	<div>
    <v-dialog
      max-width="450px"
      v-model="show"
      >
        <v-card>
          <v-form  enctype="multipart/form-data" v-model="valid" ref="form">
            <v-card-title class="d-flex justify-space-between">
              <div class="loadflex"><span class="text-h6">Update Vat</span>&nbsp;&nbsp;<div class="load"><v-progress-circular
                    color="primary"
                    indeterminate
                    :size="18"
                    :width="3"
                    v-show="loader"></v-progress-circular></div></div>
            </v-card-title>

            <v-card-text>
                <v-container class="mt-0 mx-0 px-0 mb-0">
                  <v-row>
                    <v-col
                      cols="12"
                      sm="12"
                      md="12"
                      >
                      <v-text-field
                        label="Vat*"
                        v-model="item.vat"
                        :rules="fieldRules"
                        hide-details
                      ></v-text-field>
                    </v-col>
                    <v-col
                      cols="12"
                      sm="12"
                      md="12"
                      >
                      <v-text-field
                        label="Witholding Tax"
                        v-model="item.witholdingtax"
                        hide-details
                      ></v-text-field>
                    </v-col>
                  </v-row>
                </v-container>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
                <v-btn
                  color="default darken-1"
                  text
                  @click.stop="show = false"
                >
                  Close
                </v-btn>
                <v-btn
                  color="primary darken-1"
                  text
                  :loading="loading"
                  :disabled="!valid"
                  @click="updatevat"
                >
                  Submit
                </v-btn>
            </v-card-actions>
          </v-form>
        </v-card>
    </v-dialog>
	</div>
</template>

<style>
  .modal-waitingtime{
    max-width:550px !important;
  }
</style>

<script>
import axios from 'axios'
import moment from 'moment'
import { format, parseISO } from 'date-fns'
import Vue from 'vue'

export default {
	name: 'vat',
	components: {
	},
	data: () => ({
		fieldRules: [
          (v) => !!v || 'Field is required'
          ],
        valid: true,
        isBusy: false,
        loading: false,
        disabled: false,
        item: {
          vat: "",
          witholdingtax: "",
        }
	}),
	methods: {
    getSettingsDetails(){
        this.$store.state.componentloader = true
        this.$store
          .dispatch('getConfig')
          .then(() => {
            this.$store.state.componentloader = false
          })
          .catch(() => {
            this.$store.state.componentloader = false
          })
      },
    updatevat(){

      this.loading = true

      const config = { headers: { 'Content-Type': 'multipart/form-data' } };
      let fd = new FormData();
      fd.append('rate',this.item.vat)
      fd.append('witholding',this.item.witholdingtax)

      axios.post('/vat', fd, config).then(response=>{
        if(response.data.status == parseInt(200)) {

          this.$toast.success('Vat updated successfully','Success',{position: 'topRight',timeout: 7000,})

          this.getSettingsDetails()
          this.show = false
        }
          this.loading = false
        })
        .catch(() => {
          this.loading = false
        })
    },
	},
	props: {
	     value: Boolean
	  },
	  computed: {
      loader() {
        return this.$store.state.componentloader
      },
      settingsVehicleType() {
        return this.$store.state.settingsVehicleType
      },
	    show: {
	      get () {
	        return this.value
	      },
	      set (value) {
	         this.$emit('input', value)
	      }
	    }
	  },
	mounted() {},
	created() {}
}
</script>